export const config = {
    environment: process.env.REACT_APP_ENVIRONMENT,
    appURL : process.env.REACT_APP_APPURL,
    appFormBaseURL: process.env.REACT_APP_APPFORMBASEURL,
    spcpReturnUrl: process.env.REACT_APP_SPCPRETURNURL,
    spcpForeignCroppassUEN: process.env.REACT_APP_SPCPFOREIGNCROPPASSUEN,
    cseID: process.env.REACT_APP_CSEID,
    deploymentDate: process.env.REACT_APP_DEPLOYMENTDATE,
    intervalPopupBeforeExpired: process.env.REACT_APP_INTERVALPOPUPBEFOREEXPIRED,
    baseURL: process.env.REACT_APP_BASEURL,
    vesselUploadInputSampleURL: process.env.REACT_APP_VESSEL_UPLOAD_INPUT_SAMPLE_DOWNLOAD_URL,
    form_name_target_ship_main: process.env.REACT_APP_FORMNAME_TARGET_SHIP_MAIN,
    form_name_target_ship_cr: process.env.REACT_APP_FORMNAME_TARGET_SHIP_CR,
    form_name_target_ship_mof: process.env.REACT_APP_FORMNAME_TARGET_SHIP_MOF,
    form_name_target_container_main: process.env.REACT_APP_FORMNAME_TARGET_CONTAINER_MAIN,
    form_name_target_container_cr: process.env.REACT_APP_FORMNAME_TARGET_CONTAINER_CR,
    form_name_target_container_mof: process.env.REACT_APP_FORMNAME_TARGET_CONTAINER_MOF,
    form_name_target_idp_main: process.env.REACT_APP_FORMNAME_TARGET_IDP_MAIN,
    form_name_target_idp_cr: process.env.REACT_APP_FORMNAME_TARGET_IDP_CR,
    form_name_target_idp_claim: process.env.REACT_APP_FORMNAME_TARGET_IDP_CLAIM,
    form_name_target_msi_main: process.env.REACT_APP_FORMNAME_TARGET_MSI_MAIN,
    form_name_original_ship_main: process.env.REACT_APP_FORMNAME_ORIGINAL_SHIP_MAIN,
    form_name_original_ship_cr: process.env.REACT_APP_FORMNAME_ORIGINAL_SHIP_CR,
    form_name_original_ship_mof: process.env.REACT_APP_FORMNAME_ORIGINAL_SHIP_MOF,
    form_name_original_container_main: process.env.REACT_APP_FORMNAME_ORIGINAL_CONTAINER_MAIN,
    form_name_original_container_cr: process.env.REACT_APP_FORMNAME_ORIGINAL_CONTAINER_CR,
    form_name_original_container_mof: process.env.REACT_APP_FORMNAME_ORIGINAL_CONTAINER_MOF,
    form_name_original_idp_main: process.env.REACT_APP_FORMNAME_ORIGINAL_IDP_MAIN,
    form_name_original_idp_cr: process.env.REACT_APP_FORMNAME_ORIGINAL_IDP_CR,
    form_name_original_idp_claim: process.env.REACT_APP_FORMNAME_ORIGINAL_IDP_CLAIM,
    form_name_original_msi_main: process.env.REACT_APP_FORMNAME_ORIGINAL_MSI_MAIN,
    wogaaURL: process.env.REACT_APP_WOGAAURL,
    isIDP: process.env.REACT_APP_IDP,
    logoURL: process.env.REACT_APP_LOGOURL,
    contactUsURL: process.env.REACT_APP_CONTACTUSURL,
    bannerStartDate: process.env.REACT_APP_BANNER_START_DATE,
    bannerEndDate: process.env.REACT_APP_BANNER_END_DATE,
    bannerMessage: process.env.REACT_APP_BANNER_MESSAGE,
    shipCrBannerStartDate: process.env.REACT_APP_SHIP_CR_BANNER_START_DATE,
    shipCrBannerEndDate: process.env.REACT_APP_SHIP_CR_BANNER_END_DATE,
    shipCrBannerMessage: process.env.REACT_APP_SHIP_CR_BANNER_MESSAGE,
    containerCrBannerStartDate: process.env.REACT_APP_CONTAINER_CR_BANNER_START_DATE,
    containerCrBannerEndDate: process.env.REACT_APP_CONTAINER_CR_BANNER_END_DATE,
    containerCrBannerMessage: process.env.REACT_APP_CONTAINER_CR_BANNER_MESSAGE,
    scamBannerStartDate: process.env.REACT_APP_SCAM_BANNER_START_DATE
}

export const fileAssets = {
    FAQ_NET_TONNAGE_PDF_PATH: process.env.PUBLIC_URL + '/docs/omp-documents-files/faq-on-ntt-basis.pdf',
}

export const fileExternalLinks = {
    POOL_OPERATION_PATH: 'https://www.mpa.gov.sg/api/media/2c0aee16-c72d-4df1-ae25-bc1b8739b2d7/general-guidelines-for-pool-operations.pdf',
    TAX_EXEMPTION_VESSEL_DISPOSAL_PATH: 'https://www.mpa.gov.sg/api/media/6e1fcdbd-24a0-4a8c-844a-857675ee0a17/faq-msi-tax-exemption-of-vessel-disposal-gains-jan2022.pdf',
    TAX_EXEMPTION_SHIP_MANAGEMENT_PATH: 'https://www.mpa.gov.sg/api/media/4cb409db-b48d-404b-81c8-022a3db235a8/faq-msi-tax-exemption-on-in-house-ship-management-income-feb2025.pdf',
    MINIMUM_COMMITMENTS_PATH: 'https://www.mpa.gov.sg/api/media/fbe6f5e6-118a-4266-aca3-85671a6959f6/faq-on-minimum-commitments-under-msi.pdf',
}